import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addressTypeOption, FR_SUFFIX, licencePlateOption, odsCallOutBoxs } from "../../entities/Constants";
import { Checkbox } from "primereact/checkbox";
import { Editor } from "primereact/editor";
import { InputTextarea } from "primereact/inputtextarea";
import Utils from "../../utilities/Utils";

import { DialogBase, Props, State } from "./DialogBase";
import { isInputElement } from "../../utilities/ElementUtils";



export class DialongforLicensePlate extends DialogBase<Props,State> {

    constructor(props: Props) {
        super(props);

    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={"Set up API for section " + this.props.ele.ENUTitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.licensePlateHtml()}
                </Dialog>
            </>
        );
        return html;
    }

    licensePlateHtml = () => {
        let htmlString = [];
        htmlString.push(
            <>
                
                {this.regexHtml()}

                {this.questionHintHtml()}

                {this.tooTipHtml()}

                {this.emptyErrorMessageHtml()}

                {this.errorMessageHtml()}

                {this.hintExpansionTitleHtml()}

                {this.calloutBoxHtml()}

                {this.scriptHtml()}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    
                                        <div style={{ width: '25%' }}>
                                            <label htmlFor={"text_type_" + this.props.ele.Sequence}>Max Length:</label>
                                        </div>
                                        <div style={{ width: '60%' }}>
                                            {/* @ts-ignore */}
                                            <InputText className="ontario-input"
                                                value={this.props.ele.maxLength?.toString()}
                                                onChange={(e) => {
                                                        this.props.ele.maxLength = Number(e.target.value);
                                                        this.props.callback()
                                                }}
                                            />
                                        </div>
                                    </div>
                <div style={{ display: "flex", marginTop: '10px' }}>

                    <div style={{ width: '25%' }}>
                        <label htmlFor={"text_type_" + this.props.ele.Sequence}>Regex for licence plate:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <InputText className="ontario-input"
                            value={this.props.ele.licensePlateRegex}
                            onChange={(e) => {
                                this.props.ele.licensePlateRegex = e.target.value;
                                this.props.callback()
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                                    <div style={{ width: '25%' }}>License plate type: </div>
                                    <div style={{ width: '60%' }}>
                                        {/* @ts-ignore */}
                                        <Dropdown showClear options={licencePlateOption} optionLabel='label' optionValue='val' value={this.props.ele.licensePlateType}
                                            onChange={(e) => {
                                                this.props.ele.licensePlateType = e.target.value;
                                                this.props.callback();
                                            }}
                                        ></Dropdown>
                                    </div>
                                </div>


                {this.maskSummaryHtml()}

                {isInputElement(this.props.ele) && (
                                    <div style={{ display: "flex", marginTop: '10px' }}>
                                        <div style={{ width: '25%' }}>
                                            <label htmlFor={"collect_submit" + this.props.ele.Sequence}>Collect for submit:</label>
                                        </div>
                                        <div style={{ width: '60%' }}>
                                            {/* @ts-ignore */}
                                            <Checkbox value={this.props.ele.input?.submitCollect} 
                                                id={"collect_submit" + this.props.ele.Sequence}
                                                onChange={(e) => { 
                                                    this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: e.checked}; 
                                                    this.props.callback() 
                                                }} 
                                                checked={this.props.ele.input?.submitCollect}
                                            />
                                        </div>
                                    </div>
                                )}
                
            </>
        )

        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
